module.exports = __webpack_public_path__ + "static/media/icon_export.9326dd1e.svg";